import React from 'react';

import { DEFAULT_ICON_PROPS, IIconProps } from '../constants';

export const FacebookBlueIcon = ({ ariaLabel = 'Facebook', ...props }: IIconProps) => {
  const {
    size,
    width,
    height,
    title,
    ariaHidden,
    className,
    strokeLinecap = 'inherit',
    strokeLinejoin = 'inherit',
  } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}
      <g clipPath="url(#clip0_1201_13755)">
        <rect width="32" height="32" rx="4" fill="white" />
        <path
          d="M15.9996 -0.666669C11.5715 -0.666669 2.89687 -2.90717 -0.000183344 -5.96046e-07C-2.88403 2.89392 -1.33344 11.6268 -1.33344 16.0347C-1.33344 19.3044 -1.6851 29.2729 -0.000340581 31.8027C2.44796 35.4789 9.04719 32.4504 13.6076 33.136V20.24H9.64898V16.0347H13.6076V13.236C13.6076 8.60266 15.865 6.56933 19.7156 6.56933C21.5596 6.56933 22.5356 6.70666 22.997 6.768V10.4387H20.3703C18.7356 10.4387 18.165 11.9893 18.165 13.736V16.0347H22.9556L22.3063 20.24H18.165V33.1693C22.4263 32.5916 29.4898 35.078 31.9996 31.836C34.0893 29.1368 32.6663 19.0134 32.6663 15.3333C32.6663 11.0943 34.6909 2.86298 31.9996 -5.96046e-07C29.0811 -3.10478 20.5966 -0.666669 15.9996 -0.666669Z"
          fill="#166CF0"
          strokeLinecap={strokeLinecap}
          strokeLinejoin={strokeLinejoin}
        />
      </g>
      <defs>
        <clipPath id="clip0_1201_13755">
          <rect width="32" height="32" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
